import { render, staticRenderFns } from "./ImageHandler.vue?vue&type=template&id=247e7d09&scoped=true"
import script from "./ImageHandler.vue?vue&type=script&lang=js"
export * from "./ImageHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247e7d09",
  null
  
)

export default component.exports